import { Say } from "../../../languages";

export const OrderConfirmationSelfieOnlyText = () => (
  <div className="OrderConfirmationSelfieOnlyText order-confirmation__selfie-text">
    <p className="zeta">
      <Say phrase="photo_step.step_heading" />
    </p>
  </div>
);

export default OrderConfirmationSelfieOnlyText;
